import React, { useMemo, useRef, useState } from "react"
import ReportColumnSelector from "components/Common/ReportColumnSelector"
import { Button, Col, Form, Input, Label, Row } from "reactstrap"

import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import moment from "moment"
import { useSelector, useDispatch } from "react-redux"
import { isObject } from "lodash"
import Select from "react-select"
import {
  getProviderFacilities,
  getProviderItemCategories,
  getProviderItems,
} from "store/provider-dashboard/provider-dashboard-action"
import { providerDashboardAction } from "store/provider-dashboard/provider-dashboard-slice"
import { DISTRIBUTEDDETAIL } from "constants/data"

const ProviderDistributionReportFilter = ({
  onAdvancedSearchSubmit,
  loading,
  columns = [],
  onToggleColumn = () => {},
  onReorder = () => {},
}) => {
  const dateFlatpickerfrom = useRef(null)
  const dateFlatpickerto = useRef(null)
  const [category, setCategory] = useState(null)
  const [item, setItem] = useState(null)
  const [shipment, setShipment] = useState(null)
  const [fundCode, setFundCode] = useState(null)
  const [commodityClassification, setCommodityClassification] = useState(null)
  const [warehouse, setWarehouse] = useState(null)
  const [geoRegion, setGeoRegion] = useState(null)
  const [trType, setTrType] = useState(null)
  const [province, setProvince] = useState(null)
  const [facility, setFacility] = useState(null)
  const [ip, setIP] = useState(null)
  const [project, setProject] = useState(null)
  const [currency, setCurrency] = useState(null)
  const [warehouse_disribute, setWarehouseDistribute] = useState(null)
  const [receiptNumber, setReceiptNumber] = useState("")
  const [expireDate, setExpireDate] = useState({
    from: null,
    to: null,
  })

  const dispatch = useDispatch()

  const [date, setDate] = useState({
    from: null,
    to: null,
  })

  // Retrieve categories data from Redux store
  const categories = useSelector(
    state => state.providerDashboard.ProviderItemCategoires
  )

  // Retrieve items data from Redux store
  const items = useSelector(state => state.providerDashboard.ProviderItems)

  // Retrieve provinces data from Redux store
  const provinces = useSelector(
    state => state.providerDashboard.providerProvinces
  )

  // Retrieve projects data from Redux store
  const projects = useSelector(
    state => state.providerDashboard.providerProjects
  )

  // Retrieve ips data from Redux store
  const ips = useSelector(state => state.providerDashboard.ProviderIps)

  // Retrieve facilities data from Redux store
  const facilities = useSelector(
    state => state.providerDashboard.providerFacilities
  )

  // Retrieve warehouses data from Redux store
  const warehouses = useSelector(
    state => state.providerDashboard.providerWarehouses
  )

  // Retrieve currencies data from Redux store
  const currencies = useSelector(
    state => state.providerDashboard.ProviderCurrencies
  )

  const shipments = useSelector(
    state => state.providerDashboard.ProviderShipments
  )
  const fundCodes = useSelector(
    state => state.providerDashboard.ProviderFundCodes
  )
  const commodityClassifications = useSelector(
    state => state.providerDashboard.ProviderCommodityClassifications
  )

  // get filtered items based select box props needs
  const filteredItems = useMemo(
    () =>
      items?.data.map(item => ({
        value: item.id,
        label: `${item.unfp_item_name} ( ${item.item_name} )`,
      })),
    [items]
  )

  // Store filtered data and dispatch the action using onAdvancedSearchSubmit callback function
  const handleSubmit = () => {
    let data = {}

    data.date = {
      from: date.from ? date.from : null,
      to: date.to ? date.to : null,
    }
    if (item) {
      data.item = item.map(ite => (ite.value ? ite.value : ite))
    }

    data.category = isObject(category) ? category.value : null
    data.shipment = isObject(shipment) ? shipment.value : null
    data.fundCode = isObject(fundCode) ? fundCode.value : null
    data.commodityClassification = isObject(commodityClassification)
      ? commodityClassification.value
      : null
    data.warehouse = isObject(warehouse) ? warehouse.value : null
    data.geoRegion = isObject(geoRegion) ? geoRegion.value : null
    data.trType = isObject(trType) ? trType.value : null
    data.project = isObject(project) ? project.value : null
    data.currency = isObject(currency) ? currency.value : null
    data.ip = isObject(ip) ? ip.value : null
    data.province = isObject(province) ? province.value : null
    data.facility = isObject(facility) ? facility.value : null
    data.warehouse_disribute = isObject(warehouse_disribute)
      ? warehouse_disribute.value
      : null
    data.receiptNumber = receiptNumber

    onAdvancedSearchSubmit(data)
  }

  // clear search when clear button clicked
  const onClearHandler = () => {
    dateFlatpickerfrom.current.flatpickr.clear()
    dateFlatpickerto.current.flatpickr.clear()
    setItem(null)
    setCategory(null)
    setShipment(null)
    setFundCode(null)
    setCommodityClassification(null)
    setGeoRegion(null)
    setTrType(null)
    setWarehouse(null)
    setCurrency(null)
    setDate({ from: null, to: null })
    setProvince(null)
    setFacility(null)
    setIP(null)
    setProject(null)
    setReceiptNumber("")
    onAdvancedSearchSubmit({})
    setWarehouseDistribute(null)
    dispatch(providerDashboardAction.resetProviderItems())
    dispatch(providerDashboardAction.resetProviderFacilities())

    onAdvancedSearchSubmit({})
  }

  // store Item Categories and fetch items based item category
  const onCategoryChangeHandler = cate => {
    setCategory(cate)
    dispatch(getProviderItems(cate.value))
  }

  const onCommodityClassificationChangeHandler = value => {
    setCommodityClassification(value)
    setCategory(null)
    setItem(null)
    dispatch(providerDashboardAction.resetProviderItems())
    dispatch(getProviderItemCategories(value?.value ?? null))
  }

  // store multiple items based selected
  const onItemChangeHandler = item => {
    const check = item.some(ite => ite.value === "all")
    if (check) {
      setItem(filteredItems)
    } else {
      setItem(item)
    }
  }

  // store warehouse value
  const onWarehouseChange = warehouse => {
    setWarehouse(warehouse)
  }

  // store region value
  const onGeoRegionChangeHandler = region => {
    setGeoRegion(region)
  }
  // store transaction type value
  const onTransactionTypeChange = type => {
    setTrType(type)
  }

  // store province value and fetch facilities based province id
  const onProvinceChangeHandler = value => {
    setProvince(value)
    setFacility("")
    dispatch(getProviderFacilities(value.value))
  }

  // store facility value
  const onFacilityChangeHandler = value => {
    setFacility(value)
  }

  // store ip value
  const onIPChangeHandler = value => {
    setIP(value)
  }

  // store project value
  const onProjectChangeHandler = value => {
    setProject(value)
  }

  // store warehouse distribute value
  const onWarehouseDistributeChangeHandler = value => {
    setWarehouseDistribute(value)
  }

  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        handleSubmit()
        return false
      }}
    >
      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">IPs</Label>
            {ips?.data && (
              <Select
                options={ips?.data}
                value={ip}
                onChange={onIPChangeHandler}
              />
            )}
          </Col>
          <Col>
            <Label className="form-label">Projects</Label>
            {projects?.data && (
              <Select
                options={projects?.data}
                value={project}
                onChange={onProjectChangeHandler}
              />
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Currency</Label>
            {currencies?.data && (
              <Select
                options={currencies?.data}
                value={currency}
                onChange={value => setCurrency(value)}
              />
            )}
          </Col>
          <Col>
            <Label className="form-label">DS Number</Label>
            <Input
              name="receipt_number"
              placeholder="DS Number"
              type="text"
              onChange={e => setReceiptNumber(e.target.value)}
              value={receiptNumber}
            />
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Shipment</Label>
            {shipments?.data && (
              <Select
                options={shipments?.data}
                value={shipment}
                onChange={value => setShipment(value)}
              />
            )}
          </Col>
          <Col>
            <Label className="form-label">Fund Code</Label>
            {fundCodes?.data && (
              <Select
                options={fundCodes?.data}
                value={fundCode}
                onChange={value => setFundCode(value)}
              />
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Unit Classification</Label>
            {commodityClassifications?.data && (
              <Select
                options={commodityClassifications?.data}
                value={commodityClassification}
                onChange={onCommodityClassificationChangeHandler}
              />
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Province</Label>
            {provinces?.data && (
              <Select
                options={provinces?.data}
                value={province}
                onChange={onProvinceChangeHandler}
              />
            )}
          </Col>
          <Col>
            <Label className="form-label">Facilities</Label>
            {facilities?.data && (
              <Select
                options={facilities?.data}
                value={facility}
                onChange={onFacilityChangeHandler}
              />
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Item Categories</Label>
            {categories?.data && (
              <Select
                options={categories?.data}
                value={category}
                onChange={onCategoryChangeHandler}
              />
            )}
          </Col>
          <Col>
            <Label className="form-label">Items</Label>
            {filteredItems && (
              <Select
                isMulti={true}
                options={[{ value: "all", label: "All" }, ...filteredItems]}
                value={item}
                onChange={onItemChangeHandler}
              />
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Warehouse</Label>
            {warehouses?.data && (
              <Select
                options={warehouses?.data}
                value={warehouse}
                onChange={onWarehouseChange}
              />
            )}
          </Col>
          <Col>
            <Label className="form-label">GEOGRAPHIC REGION</Label>
            {filteredItems && (
              <Select
                options={[
                  { value: "Central", label: "Central" },
                  { value: "North", label: "North" },
                  { value: "South", label: "South" },
                  { value: "East", label: "East" },
                  { value: "West", label: "West" },
                ]}
                value={geoRegion}
                onChange={onGeoRegionChangeHandler}
              />
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          {/* <Col>
            <Label className="form-label">Transaction Type</Label>
            {filteredItems && (
              <Select
                options={[
                  { value: "Receipts", label: "Receipts" },
                  { value: "Distribution", label: "Distribution" },
                ]}
                value={trType}
                onChange={onTransactionTypeChange}
              />
            )}
          </Col> */}
          <Col>
            <Label className="form-label">Warehouse Distribute</Label>
            <Select
              options={[{ value: "all", label: "All" }, ...DISTRIBUTEDDETAIL]}
              value={warehouse_disribute}
              onChange={onWarehouseDistributeChangeHandler}
            />
          </Col>
        </Row>
      </div>

      <div className="mb-3 ">
        <Row>
          <Col>
            <Label className="form-label">Distribution From Date</Label>
            <Flatpickr
              ref={dateFlatpickerfrom}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setDate(prev => {
                  return {
                    ...prev,
                    from: moment(value[0]).format("YYYY-MM-DD"),
                  }
                })
              }}
            />
          </Col>
          <Col>
            <Label className="form-label">Distribution To Date</Label>
            <Flatpickr
              ref={dateFlatpickerto}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setDate(prev => {
                  return { ...prev, to: moment(value[0]).format("YYYY-MM-DD") }
                })
              }}
            />
          </Col>
        </Row>
      </div>
      <ReportColumnSelector
        columns={columns}
        onToggle={onToggleColumn}
        onReorder={onReorder}
      />

      <div className="d-flex flex-wrap gap-2 mb-4">
        <Button
          type="submit"
          className="btn btn-sm btn-primary"
          color="primary"
          disabled={loading}
        >
          {loading ? "Please Wait..." : "Search"}
        </Button>
        <Button
          onClick={onClearHandler}
          className="btn btn-sm btn-danger"
          color="primary"
        >
          Clear
        </Button>
      </div>
    </Form>
  )
}

export default ProviderDistributionReportFilter
